import React from 'react';
import { Typography } from '@biome-design-system/ui/Typography';

export const SearchTermText = ({ displayText }: { displayText: string }) => {
  return (
    <span data-testid="search-results-description">
      &quot;
      <Typography
        component="span"
        sx={(theme) => ({
          fontWeight: theme.typography.fontWeightBold
        })}
      >
        {displayText}
      </Typography>
      &quot;
    </span>
  );
};
